import { cn } from '../lib/utils';

export function PageHeader({ title, subtitle, actions, className, ...rest }) {
    return (
        <div
            className={cn('flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between', className)}
            {...rest}
        >
            <div>
                <h1 className="font-heading text-2xl sm:text-3xl tracking-tight" data-testid="page-title">
                    {title}
                </h1>
                {subtitle && (
                    <p className="text-sm text-muted-foreground mt-1 max-w-2xl">{subtitle}</p>
                )}
            </div>
            {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
        </div>
    );
}
